module.exports = __webpack_public_path__ + "static/media/W09F2152-WEB5.5edde7c9.svg";